'use strict';

var $    = require('jquery');
var InspectorCore = require('../core/core_inspector.js');

/**
 * Creates an inspector text input field
 *
 * @class
 */

class InspectorTextInput extends InspectorCore {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': '',
                'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item">
				<div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div>
				<input class="editor__inspector__item__textinput js-inspector__textinput__value" type="text" value="<%- value %>">
			</div>
		`;

		super.render();

		/**
		* Text input
		*
		* @fires InspectorTextInput#_valuechanged
		*/

		$('.js-inspector__textinput__value', this.$el).on('input', this._valuechanged);
		$('.js-inspector__textinput__value', this.$el).on('focus', this._focus);
		$('.js-inspector__textinput__value', this.$el).on('blur', this._blur);

		var self = this;
		$('.js-inspector__textinput__value', this.$el).keypress(function(e) {
            if (e.which == 13) {
            	self._enter(e);
            }
		});
	}

	/**
     * @event InspectorTextInput#Cioui:Inspector:value
     * @property {String}Cioui:Inspector:value
     * @returns {String} value - the new text input obj
     */

	_valuechanged(e){
		$(e.currentTarget).trigger('Cioui:Inspector:value', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:focus
     * @property {String}Cioui:Inspector:focus
     * @returns {String} value - the new text input obj
     */
	_focus(e){
		$(e.currentTarget).trigger('Cioui:Inspector:focus', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:blur
     * @property {String}Cioui:Inspector:blur
     * @returns {String} value - the new text input obj
     */
	_blur(e){
		$(e.currentTarget).trigger('Cioui:Inspector:blur', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:enter
     * @property {String}Cioui:Inspector:enter
     * @returns {String} value - the new text input obj
     */
	_enter(e){
        $(e.currentTarget).trigger('Cioui:Inspector:enter', $(e.currentTarget).val());
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector__textinput__value', this.$el).val(value);
	}
}
module.exports = InspectorTextInput;